import React from "react"
import { Container, Row, Col } from "react-bootstrap"
import "../../styles/help-center.scss"

const SearchSection = () => {
  return (
    <section id="search-section">
      <Container>
        <Row className="justify-content-center text-center">
          <Col md={8}>
            <h1>
              Search below and see for yourself how easy it is using Rehab Find!
            </h1>
            <div className="form-group has-search mt-5">
              <span className="fa fa-search search-icon "></span>
              <input
                type="text"
                className="form-control"
                placeholder="How Can We Help You?"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default SearchSection
